import {
  RULES_MAPPING_SUCCESS,
  RULES_MAPPING_FAILED,
  RESET_RULES_MAPPING,
  LOADING_RULES_MAPPING,
  NETWORK_ERROR_RULES_MAPPING,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetRulesMapping = () => {
  return { type: RESET_RULES_MAPPING };
};

const getRulesMapping = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_RULES_MAPPING });
  await partnerServices
    .post("rulesMappingForMerchant", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(rulesMappingsuccess(res.data));
          break;
        default:
          dispatch(rulesMappingFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_RULES_MAPPING, payload: err });
    });
};
function rulesMappingsuccess(data) {
  return {
    type: RULES_MAPPING_SUCCESS,
    payload: data,
  };
}
function rulesMappingFailed(data) {
  return {
    type: RULES_MAPPING_FAILED,
    payload: data,
  };
}

export { resetRulesMapping, getRulesMapping };
